module.exports = __webpack_public_path__ + "static/media/validar.e5eeb930.svg";